import { useState } from "react";
import { addDoc, collection, doc, updateDoc, arrayUnion } from "firebase/firestore";
import { auth, db } from "../firebase";
import "../css/dash.css";

export default function CreateMenuButton({ onMenuCreated }) {
  const [showModal, setShowModal] = useState(false);
  const [menuName, setMenuName] = useState("");
  const [tagLine, setTagLine] = useState("");
  const [isPublic, setIsPublic] = useState(false);
  const [loading, setLoading] = useState(false);

  const createMenu = async () => {
    if (!menuName.trim()) {
      alert("Please enter a menu name.");
      return;
    }

    try {
      setLoading(true);
      const newMenuRef = await addDoc(collection(db, "menus"), {
        name: menuName.trim(),
        public: isPublic,
        views: 0,
        owner: auth.currentUser.uid,
        tagline: tagLine,
        style: "style1",
        createdAt: new Date(),
      });

      const userDocRef = doc(db, "users", auth.currentUser.uid);
      await updateDoc(userDocRef, {
        menus: arrayUnion(newMenuRef.id),
      });

      alert("✅ New menu created!");
      setShowModal(false);
      setMenuName("");
      setIsPublic(false);
      window.location.reload();

      if (onMenuCreated) onMenuCreated();
    } catch (e) {
      console.error("Error creating menu:", e);
      alert("There was an issue creating your menu.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button className="addbtn" onClick={() => setShowModal(true)}>
        + Create New Menu
      </button>

      {showModal && (
        <div className="modalOverlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>Create New Menu</h2>
            <input
              type="text"
              className="modalInput"
              placeholder="Menu Name"
              value={menuName}
              onChange={(e) => setMenuName(e.target.value)}
            />
            <input
              type="text"
              className="modalInput"
              placeholder="Tag Line"
              value={tagLine}
              onChange={(e) => setTagLine(e.target.value)}
            />
            <div className="visibilityToggle">
              <label>
                <input
                  type="checkbox"
                  checked={isPublic}
                  onChange={(e) => setIsPublic(e.target.checked)}
                />
                Publicly Visible
              </label>
            </div>

            <div className="modalActions">
              <button
                className="cancelBtn"
                onClick={() => setShowModal(false)}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                className="createBtn"
                onClick={createMenu}
                disabled={loading}
              >
                {loading ? "Creating..." : "Create"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
